import { render } from "./TrashUser.vue?vue&type=template&id=4fcb35b4"
import script from "./TrashUser.vue?vue&type=script&lang=js"
export * from "./TrashUser.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/cafemano-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__